import React from "react";

interface FilterSelectProps {
  selectedOption: string;
  handleFilterChange: (value: string) => void;
}

const FilterSelect: React.FC<FilterSelectProps> = ({
  selectedOption,
  handleFilterChange,
}) => (
  <form onSubmit={(e) => e.preventDefault()}>
    <div className="2xl:order-none flex flex-col sm:flex-row sm:items-center sm:gap-2 col-span-1 sm:col-auto">
      <label htmlFor="options" className="text-lg whitespace-nowrap">
        Choose an option:
      </label>
      <select
        id="options"
        name="options"
        className="w-full sm:w-36 h-9 border border-blue-500 rounded-2xl px-2 outline-none focus:border-blue-600 focus:ring-1 focus:ring-blue-500 cursor-pointer"
        value={selectedOption}
        onChange={(e) => handleFilterChange(e.target.value)}
      >
        <option value="Today">Today</option>
        <option value="Yesterday">Yesterday</option>
        <option value="LastWeek">Last 7 days</option>
        <option value="LastMonth">Last 30 days</option>
        <option value="180days">Last 180 days</option>
        <option value="CustomizeDate">Customize date</option>
      </select>
    </div>
  </form>
);

export default FilterSelect;
